import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation, useParams } from "react-router";
import { EditShiftMethod, GetShiftsData } from "../../Components/Services";
import {
  CostRender,
  GenderRender,
  ConvertDate,
} from "../../../../../Common/Function";
import Loading from "../../../../../Common/Components/Loading/index";
import CustomModal from "../../../../../Common/Components/Modal/CustomModal";
import { Calendar, getAllDatesInRange } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

function Edit() {
  const location = useLocation();
  const item = location.data;
  const { type } = item.time_table;
  const initialState = {
    loading: true,
    modal: false,
  };
  const { slug } = useParams();
  const [state, setstate] = useState(initialState);
  const getShifts = () => {
    let data = {
      item_id: slug,
    };
    setstate({ ...state, loading: true });
    GetShiftsData(data).then(result => {
      if (result) {
        setstate({ data: result.times, loading: false });
      }
      return;
    });
  };
  useEffect(() => {
    getShifts();
  }, []);
  const Handler = data => {
    setstate({ loading: true, ...state });
    EditShiftMethod(data)
      .then(() => {
        setstate({ ...state, loading: false });
      })
      .then(() => getShifts());
  };

  const handlerDelete = data => {
    EditShiftMethod(data)
      .then(() => {
        setstate({ ...state, loading: false });
      })
      .then(() => getShifts());
  };

  useEffect(() => {
    var inputs = window.$(".datePickerShamsi");
    window.$.each(inputs, function (i, item) {
      window.$(item).datepicker({
        dateFormat: "yy/mm/dd",
        showOtherMonths: true,
        selectOtherMonths: false,
      });
    });
  }, []);

  const [form, setform] = useState([]);
  const Shift = ({ shift, state, setstate }) => {
    const [loading, setloading] = useState(0);
    return (
      <div className="col-md-3 mt-2 p-2 rounded text-center ">
        <div className="card shadow-sm position-relative">
          <div className="card-body" style={{ "padding-top": "34px" }}>
            <h6
              className=""
              style={{
                fontSize: "1.8rem !important",
              }}
            >
              {shift.title}
            </h6>
            <div className="d-flex flex-column">
              <span className="">
                <i className="fas fa-hourglass-start px-2"></i>
                شروع شیفت : {shift.start}
              </span>
              <span className="">
                <i className="fas fa-hourglass-start px-2"></i>
                پایان شیفت : {shift.end}
              </span>
              {type == "shiftwcount" && (
                <span className="">ظرفیت : {shift.count}</span>
              )}
            </div>

            <div className="money">
              {"second_price" in shift ? (
                <p className="">
                  قیمت :
                  <span className="text-success">
                    {CostRender.format(shift.second_price)}
                  </span>
                  <span className="text-danger mx-2">
                    <del>{CostRender.format(shift && shift.price)}</del>
                  </span>
                  <span className="text-success"> تومان </span>
                </p>
              ) : (
                <p className="">قیمت : {CostRender.format(shift.price)} </p>
              )}
              <p>ویژه {GenderRender(shift.gender)}</p>
            </div>

            <button
              className="btn btn-orange align-items-center mt-2 mx-2"
              style={{ background: "#E42A3F " }}
              onClick={() => setstate({ ...state, modal: shift.id })}
            >
              ویرایش
            </button>
            <button
              className="btn btn-orange align-items-center mt-2"
              disabled={state.data.length === 1}
              onClick={() =>
                handlerDelete({
                  delete: shift.id,
                  id: shift.id,
                  item_id: item.id,
                })
              }
            >
              حذف
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | ثبت ویرایش مجموعه </title>
      </Helmet>
      <div className="card">
        <div className="card-body">
          <div className="row">
            {state.loading ? (
              <Loading count={1} col={12} height={300} />
            ) : (
              <Fragment>
                {state.data.map((data, coutn) => (
                  <Shift
                    shift={data}
                    state={state}
                    setstate={setstate}
                    key={coutn}
                  />
                ))}
                <CustomModal
                  show={state.modal}
                  handleClose={() => {
                    setstate({ ...state, modal: false });
                  }}
                  header={"ویرایش شیفت"}
                >
                  <EditShift
                    currentShift={
                      state.data.filter(data => data.id == state.modal)[0]
                    }
                    set={Handler}
                    state={state}
                    item={item}
                  />
                </CustomModal>
              </Fragment>
            )}
          </div>

          <button
            className="btn btn-primary text-white"
            onClick={() => setstate({ ...state, modal: "new" })}
          >
            اضافه کردن شیفت
          </button>
        </div>
      </div>
    </Fragment>
  );
}
const EditShift = ({ currentShift, set, state, item }) => {
  const [editShift, seteditShift] = useState({
    title: currentShift && currentShift.title,
    start: currentShift && currentShift.start,
    end: currentShift && currentShift.end,
    price: currentShift && currentShift.price,
    second_price: currentShift && currentShift.second_price,
    second_exp: currentShift && currentShift.second_exp,
    id: state.modal === "new" ? "new" : currentShift && currentShift.id,
    item_id: item.id,
    gender: currentShift && currentShift.gender,
    count: currentShift && currentShift.count,
  });
  const { type } = item.time_table;
  useEffect(() => {
    var inputs = window.$(".datePickerShamsi");
    window.$.each(inputs, function (i, item) {
      window.$(item).datepicker({
        dateFormat: "yy/mm/dd",
        showOtherMonths: true,
        selectOtherMonths: false,
      });
    });
    window.$(`.clockpicker`).on("change", e => {
      let hours = window.$(e.target).clockpicker().data().clockpicker.hours;
      let minutes = window.$(e.target).clockpicker().data().clockpicker.minutes;
      window.$(e.target).attr("data-hours", hours);
      window.$(e.target).attr("data-minutes", minutes);
    });

    var inputs = window.$(".clockpicker");
    window.$.each(inputs, function (i, item) {
      window.$(item).clockpicker({
        donetext: "انجام شد",
        align: "right",
        autoclose: true,
      });
    });
  }, []);
  return (
    <Fragment>
      <div className="my-2">
        <div className="row">
          <div className="col-md-4">
            <label htmlFor="">نام شیفت</label>
            <input
              type="text"
              className="form-control"
              defaultValue={currentShift && currentShift.title}
              onChange={e =>
                seteditShift({ ...editShift, title: e.target.value })
              }
            />
          </div>
          <div className="col-md-4">
            <label htmlFor="">جنسیت</label>
            <select
              name=""
              id=""
              className="form-control form-control-sm"
              onChange={e =>
                seteditShift({ ...editShift, gender: e.target.value })
              }
            >
              <option value={false}>انتخاب کنید</option>
              <option
                value="men"
                selected={currentShift && currentShift.gender == "men"}
              >
                آقایان
              </option>
              <option
                value="women"
                selected={currentShift && currentShift.gender == "women"}
              >
                بانوان
              </option>
            </select>
          </div>
          <div className="col-md-4">
            <label htmlFor="">قیمت ثابت شیفت</label>
            <input
              type="number"
              className="form-control"
              placeholder=""
              defaultValue={currentShift && +currentShift.price}
              onChange={e =>
                seteditShift({ ...editShift, price: +e.target.value })
              }
            />
          </div>
          {type == "shiftwcount" && (
            <div className="col-md-4">
              <label htmlFor="">ظرفیت</label>
              <input
                type="text"
                className="form-control"
                placeholder=""
                defaultValue={currentShift && currentShift.count}
                onChange={e =>
                  seteditShift({ ...editShift, count: e.target.value })
                }
              />
            </div>
          )}

          <div className="col-md-4">
            <label htmlFor="">تایم شروع شیفت</label>

            <input
              type="text"
              className="form-control clockpicker"
              placeholder="شروع شیفت"
              id="clockpicker-2"
              autoComplete={"off"}
              defaultValue={currentShift && currentShift.start}
              onClick={() => {
                if (window.$(".clockpicker").length) {
                  var inputs = window.$(".clockpicker");
                  window.$.each(inputs, function (i, item) {
                    window.$(item).clockpicker({
                      donetext: "انجام شد",
                      align: "right",
                      autoclose: true,
                    });
                  });
                }
                window.$(`#clockpicker-2`).on("change", e => {
                  let hours = window.$(e.target).clockpicker().data()
                    .clockpicker.hours;
                  let minutes = window.$(e.target).clockpicker().data()
                    .clockpicker.minutes;
                  window.$(e.target).attr("data-hours", hours);
                  window.$(e.target).attr("data-minutes", minutes);
                  if (minutes < 10) {
                    minutes = "0" + minutes.toString();
                  }
                  if (hours < 10) {
                    hours = "0" + hours.toString();
                  }

                  seteditShift({
                    ...editShift,
                    start: `${hours}:${minutes}`,
                  });
                });
              }}
            />
          </div>
          <div className="col-md-4">
            <label htmlFor="">تایم پایان شیفت</label>
            <input
              type="text"
              className="form-control clockpicker"
              id="clockpicker-1"
              placeholder="پایان شیفت"
              autoComplete={"off"}
              defaultValue={currentShift && currentShift.end}
              onClick={() => {
                if (window.$(".clockpicker").length) {
                  var inputs = window.$(".clockpicker");
                  window.$.each(inputs, function (i, item) {
                    window.$(item).clockpicker({
                      donetext: "انجام شد",
                      align: "right",
                      autoclose: true,
                    });
                  });
                }
                window.$(`#clockpicker-1`).on("change", e => {
                  let hours = window.$(e.target).clockpicker().data()
                    .clockpicker.hours;
                  let minutes = window.$(e.target).clockpicker().data()
                    .clockpicker.minutes;
                  window.$(e.target).attr("data-hours", hours);
                  window.$(e.target).attr("data-minutes", minutes);
                  if (minutes < 10) {
                    minutes = "0" + minutes.toString();
                  }
                  if (hours < 10) {
                    hours = "0" + hours.toString();
                  }
                  seteditShift({
                    ...editShift,
                    end: `${hours}:${minutes}`,
                  });
                });
              }}
            />
          </div>
          <div className="col-md-4">
            <label htmlFor="">قیمت دوم شیفت</label>

            <input
              type="text"
              className="form-control"
              placeholder=""
              defaultValue={
                currentShift && currentShift.second_price
                  ? currentShift.second_price
                  : ""
              }
              onChange={e =>
                seteditShift({ ...editShift, second_price: e.target.value })
              }
            />
          </div>
          <div className="col-md-4">
            <label htmlFor="">تاریخ اتمام قیمت دوم</label>
            <label htmlFor="">
              تاریخ قبلی :{" "}
              {currentShift && currentShift.second_exp
                ? currentShift.second_exp
                : ""}
            </label>

            <Calendar
              eachDaysInRange
              onChange={dateObjects => {
                if (dateObjects) {
                  seteditShift({
                    ...editShift,
                    second_exp: ConvertDate(
                      `${dateObjects.year}/${dateObjects.month.number}/${dateObjects.day}`
                    ),
                  });
                }
              }}
              calendar={persian}
              locale={persian_fa}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <button
              className="btn btn-primary text-white mt-3"
              onClick={() => set(editShift)}
            >
              ثبت تغییرات شیفت
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Edit;
